module.exports = __webpack_public_path__ + "65c31ba19140a54e32278b8a703be096.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/places-to-hang-out-after-school/CoffeeShop3.jpg
// module id = 3560
// module chunks = 0